<p-button
  [label]="buttonLabel"
  [icon]="buttonIcon"
  severity="secondary"
  [text]="true"
  [size]="buttonSize"
  (click)="open()"
  [attr.aria-expanded]="visible"
  aria-controls="info-drawer">
</p-button>

<p-drawer
  [visible]="visible"
  (visibleChange)="onVisibleChange($event)"
  position="left"
  [modal]="true"
  [dismissible]="true"
  [closeOnEscape]="true"
  [style]="{ width: '400px' }"
  id="info-drawer"
  (onShow)="onShow()"
  >

  <ng-template #header>
    <div class="drawer-header-content">
      <div class="drawer-header">
        <i class="pi pi-info-circle"></i>
        <span class="drawer-title">{{ title }}</span>

        <p-button
          icon="fa-solid fa-pen-to-square"
          severity="secondary"
          [text]="true"
          size="small"
          [disabled]="!showEdit || saving || editMode"
          (click)="toggleEditMode()">
        </p-button>
      </div>
      <div class="drawer-loading-row" *ngIf="loading">
        <p-progressBar [style]="{ height: '6px' }" mode="indeterminate" />
      </div>
    </div>
  </ng-template>

  @if (items && items.length > 0) {
    <div class="info-section">

      @for (item of items; track $index) {
        @if (item.separatorBefore) {
          <hr class="info-separator">
        }

        <div class="info-row">
          <div class="info-label">
            {{ item.label }}
          <ng-container *ngIf="editMode && item.isEditable && item.isRequired">
            <span
              class="c-warn"
              [tooltip]="'translate.general.required' | translate"
            >
              (*)
            </span>
          </ng-container>
          </div>

          <div class="info-value">
            @if (editMode && item.isEditable) {
              @if (item.options && item.options.length > 0) {
                @if (item.isMultiSelect) {
                  <p-multiSelect
                    [options]="item.options"
                    optionLabel="label"
                    optionValue="value"
                    [ngModel]="item.selectedValue ?? item.value"
                    (onChange)="onItemValueChange(item, $event.value)"
                    [placeholder]="'Select value'"
                    [disabled]="saving || item.readonly"
                    appendTo="body"
                    [autoZIndex]="true"
                    [baseZIndex]="1100">
                  </p-multiSelect>
                } @else {
                  <p-select
                    [options]="item.options"
                    optionLabel="label"
                    optionValue="value"
                    [showClear]="true"
                    [ngModel]="item.selectedValue ?? item.value"
                    (onChange)="onItemValueChange(item, $event.value)"
                    [placeholder]="'Select value'"
                    appendTo="body"
                    [disabled]="saving || item.readonly"
                    [autoZIndex]="true"
                    [baseZIndex]="1100">
                  </p-select>
                }
              } @else {
                <input
                  type="text"
                  class="info-input"
                  [disabled]="saving || item.readonly"
                  [ngModel]="getInputValue(item.value)"
                  (ngModelChange)="onItemValueChange(item, $event)">
              }
            } @else {
              {{ displayValue(item.value) }}
            }
            
          </div>
        </div>
      }

    </div>
  }

  @if (tabs && tabs.length > 0) {
    <p-tabs [value]="tabs[0].value" class="info-tabs">
      <p-tablist>
        @for (tab of tabs; track tab.value) {
          <p-tab [value]="tab.value">
            {{ tab.label }}
          </p-tab>
        }
      </p-tablist>

      <p-tabpanels>
        @for (tab of tabs; track tab.value) {
          <p-tabpanel [value]="tab.value">
            @if (tab.content) {
              <div class="tab-content">
                {{ tab.content }}
              </div>
            }
          </p-tabpanel>
        }
      </p-tabpanels>
    </p-tabs>
  }

  <ng-template #footer>
    @if (editMode) {
      <div class="info-drawer-footer">
        <p-button
          [label]="saving ? 'Saving...' : 'Save changes'"
          icon="pi pi-save"
          [loading]="saving"
          [disabled]="!isValid || !hasChanges || saving"
          (click)="onSaveChanges()">
        </p-button>
        <p-button
          label="Cancel"
          icon="pi pi-undo"
          severity="secondary"
          [disabled]="saving"
          (click)="onCancelChanges()">
        </p-button>
      </div>
    }
  </ng-template>

</p-drawer>